import React from "react";

import { Alert, AlertProps } from "@mui/material";

import { InfoRounded } from "@mui/icons-material";

export const Hint = ({
  hintValue,
  ...props
}: {
  hintValue: React.ReactNode;
} & AlertProps) => {
  const iconMapping = {
    success: (
      <InfoRounded fontSize="small" sx={{ "&&": { color: "success.light" } }} />
    ),
    info: (
      <InfoRounded
        fontSize="small"
        sx={{ "&&": { color: "secondary.main" } }}
      />
    ),
    warning: (
      <InfoRounded fontSize="small" sx={{ "&&": { color: "warning.light" } }} />
    ),
    error: (
      <InfoRounded fontSize="small" sx={{ "&&": { color: "error.light" } }} />
    ),
  };

  return (
    <Alert
      variant={"filled"}
      iconMapping={iconMapping}
      sx={{ textAlign: "left" }}
      {...props}
    >
      {hintValue}
    </Alert>
  );
};
